import {
  FETCH_INFO_REQUEST,
  FETCH_INFO_SUCCESS,
  FETCH_INFO_FAILURE,
  CREATE_INFO_REQUEST,
  CREATE_INFO_SUCCESS,
  CREATE_INFO_FAILURE,
  UPDATE_INFO_REQUEST,
  UPDATE_INFO_SUCCESS,
  UPDATE_INFO_FAILURE,
  DELETE_INFO_REQUEST,
  DELETE_INFO_SUCCESS,
  DELETE_INFO_FAILURE,
} from "./restaurantinfoActionType";
const initialState = {
  infoData: [],
  loading: false,
  error: null,
};
const restaurantinfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        infoData: action.payload.data,
      };
    case FETCH_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        infoData: [],
      };
    case CREATE_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        infoData: action.payload.data,
        error: null,
      };
    case CREATE_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        infoData: action.payload.data,
        error: null,
      };
    case UPDATE_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        infoData: action.payload.data,
        error: null,
      };
    case DELETE_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
export default restaurantinfoReducer;
